import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { BoxContainer } from "../layouts/Theme";
import { useSettings } from "../context/SettingsContext";
import { useI18N } from "../context/I18NContext";
import SigninForm from "../partials/account/SigninForm";
import ExternalLogin from "../partials/ExternalLogin";
export default function Login(props) {
    const { hasAccounts, hasGoogleLogin, } = useSettings();
    const { t } = useI18N();
    return (_jsxs(BoxContainer, { children: [hasAccounts === true && (_jsx(SigninForm, {})), hasGoogleLogin === true && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", component: "div", children: t('Of log in met je Google account') }), _jsx(ExternalLogin, {})] }))] }));
}
